import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Dialog, ShareSheet } from 'vant'
Vue.use(Dialog)
Vue.use(ShareSheet)
// Vue.use(Popup)

import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video

import cue from '@/utils/cue.js'
Vue.prototype.$cue = cue
import format from '@/utils/format.js'
Vue.prototype.$format = format

import moment from 'moment'
moment.locale('zh-cn')
Vue.prototype.$moment = moment

import { formatDate, formatOrderDate } from '@/utils/filters.js'
Vue.filter('formatDate', formatDate)
Vue.filter('formatOrderDate', formatOrderDate)

// 米转千米
Vue.filter('setMorKm', function (value) {
  if (!value) return ''
  return (value / 1000).toFixed(1)
})

// 姓名加密
Vue.filter('encryptName', function (name) {
  if (!name) {
    return ''
  }
  var newStr
  if (name.length === 2) {
    newStr = name.substr(0, 1) + '*'
  } else if (name.length > 2) {
    var char = ''
    for (var i = 0, len = name.length - 2; i < len; i++) {
      char += '*'
    }
    newStr = name.substr(0, 1) + char + name.substr(-1, 1)
  } else {
    newStr = name
  }
  return newStr
})

// 需要使用到uni.webview.js的一些方法
import * as uniWebView from '@/utils/uni_webview'

document.addEventListener('UniAppJSBridgeReady', () => {
  // 将uniWebView赋值给vue原型，方便调用
  Vue.prototype.$myUni = uniWebView
})

import VConsole from 'vconsole'

// 本地开发和测试环境打开 vconsole
if (process.env.NODE_ENV === 'development') {
  new VConsole()
}
new VConsole()

// import ScanLogin from 'scan-login-mf'
// Vue.use(ScanLogin)

// 阻止启动生产消息。开发环境下，Vue 会提供很多警告来帮助对付常见的错误
// Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
